import axiosCustom from "common/components/apiConfig";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
	selectCodalParticipation: "[selectCodalParticipation] Action",
	selectCodalParticipationLoading: "[selectCodalParticipationLoading] Action",
	selectCodalParticipationAsync: "[selectCodalParticipationAsync] Action",
};

const initialState = {
	data: [],
	size: 10,
	total: 0,
	loading: false,
};

export const select_codal_participation_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectCodalParticipation:
			return {
				...state,
				data: payload.results,
				total: payload.total
					? payload.total > 10000
						? 10000
						: payload.total
					: 0,
			};
		case actionTypes.selectCodalParticipationLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.selectCodalParticipationLoading,
		payload: true,
	});

	let config = {
		url: "select_request",
	};

	let data = {
		table: "codal",
		method_type: "select_codal_participation",
		data: payload?.data ? payload?.data : {},
		// from: payload.from ? (payload.from - 1) * payload.size : 0,
		// size: payload.size,
		// sort_by: payload.sort_by,
	};

	try {
		let res = yield axiosCustom(config, data);

		let isOk = handleNotificationAlertTrySelect(res);
		if (!isOk) return;

		yield put({
			type: actionTypes.selectCodalParticipation,
			payload: res.data.response.data,
		});
	} catch {
		handleNotificationAlertCatch();
	} finally {
		yield put({
			type: actionTypes.selectCodalParticipationLoading,
			payload: false,
		});
	}
}

export function* selectCodalParticipation() {
	yield takeLatest(actionTypes.selectCodalParticipationAsync, handleWorker);
}
